module.exports = __webpack_public_path__ + "static/img/top-bg.cbe333e9.png";